import React from 'react';

const SVG = ({ style = {}, colors, width = '100%', viewBox = '0 0 400 400' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M 240,0 L 399,84 157,140 0,56" fill={colors.light} />
      <path d="M 157,399 L 0,315 0,56, 157,140" fill={colors.medium} />
      <path d="M 399,84 L 399,341 157,399 157,140" fill={colors.dark} />
    </g>
  </svg>
);

export default SVG;
